import {
  CORE_LOAD_ALL_ROOMDISABLE_REQUEST,
  CORE_LOAD_ALL_ROOMDISABLE_SUCCESS,

  CORE_LOAD_ROOMDISABLE_REQUEST,
  CORE_LOAD_ROOMDISABLE_SUCCESS,

} from '../../types'

const initialState = []
export default {
  roomDisableList: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_ROOMDISABLE_REQUEST:
        return []
      case CORE_LOAD_ALL_ROOMDISABLE_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  roomDisable: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ROOMDISABLE_REQUEST:
        return {}
      case CORE_LOAD_ROOMDISABLE_SUCCESS:
        return action.payload
      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/roomDisable/reducer.js